import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateTestimonial } from "./api";
import { invalidateAllTestimonialsQueries, withUploadedVideo } from "../query";

export function useUpdateTestimonial() {
  return useMutation({
    mutationFn: async ({ item, testimonialId }) => {
      // Dirty values only; keep empty strings/nulls so fields can be cleared.
      const payload = await withUploadedVideo(item);
      const response = await updateTestimonial({ item: payload, testimonialId });
      return response;
    },
    onSuccess: () => {
      toast.success("Testimonial Updated Successfully");
      invalidateAllTestimonialsQueries();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
